import { render, staticRenderFns } from "./NotificationDropdown.vue?vue&type=template&id=64c56500&scoped=true"
import script from "./NotificationDropdown.vue?vue&type=script&lang=ts"
export * from "./NotificationDropdown.vue?vue&type=script&lang=ts"
import style0 from "./NotificationDropdown.vue?vue&type=style&index=0&id=64c56500&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c56500",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c56500')) {
      api.createRecord('64c56500', component.options)
    } else {
      api.reload('64c56500', component.options)
    }
    module.hot.accept("./NotificationDropdown.vue?vue&type=template&id=64c56500&scoped=true", function () {
      api.rerender('64c56500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notification/NotificationDropdown.vue"
export default component.exports